import React from 'react';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';

import CrmTextField from './CrmTextField';
import PhoneInput from './PhoneInput';

const localStyles = (theme) => ({
  root: {
    marginTop: '12px',
  },
});

class NewPersonalReferrerPanel extends React.Component {
  render() {
    const { classes, ownerModal, personLabel } = this.props;

    return (
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <CrmTextField
              label={personLabel}
              id="contactName"
              fullWidth
              required
              value={ownerModal.state.contactName}
              onChange={(event) => ownerModal.handleTextChange(event)}
            />
          </Grid>
          <Grid item xs={12}>
            <CrmTextField
              label="Relationship"
              id="relationship"
              fullWidth
              required
              value={ownerModal.state.relationship}
              onChange={(event) => ownerModal.handleTextChange(event)}
            />
          </Grid>
          <Grid item xs={12}>
            <CrmTextField
              label="Description"
              id="contactDescription"
              fullWidth
              value={ownerModal.state.contactDescription}
              onChange={(event) => ownerModal.handleTextChange(event)}
            />
          </Grid>
          <Grid item xs={6}>
            <PhoneInput
              label="Phone 1"
              possibleRoles={ownerModal.possibleContactPhoneRoles}
              actualRoles={ownerModal.state.contactPhone1Roles}
              number={ownerModal.state.contactPhone1Number}
              onRolesChange={(rolesObj) => ownerModal.handleContactPhone1RolesChange(rolesObj)}
              onNumberChange={(newNumber) => ownerModal.handleContactPhone1NumberChange(newNumber)}
            />
          </Grid>
          <Grid item xs={6}>
            <PhoneInput
              label="Phone 2"
              possibleRoles={ownerModal.possibleContactPhoneRoles}
              actualRoles={ownerModal.state.contactPhone2Roles}
              number={ownerModal.state.contactPhone2Number}
              onRolesChange={(rolesObj) => ownerModal.handleContactPhone2RolesChange(rolesObj)}
              onNumberChange={(newNumber) => ownerModal.handleContactPhone2NumberChange(newNumber)}
            />
          </Grid>
          <Grid item xs={12}>
            <CrmTextField
              label="Email"
              id="contactEmail"
              fullWidth
              value={ownerModal.state.contactEmail}
              onChange={(event) => ownerModal.handleTextChange(event)}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(localStyles)(NewPersonalReferrerPanel);
